module.exports = __webpack_public_path__ + "img/5-2_Create_Causal_Graph_Flow.924de99b.png";